import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'bookSalesDemoOpened',
  'bookSalesDemoBooked',
  'bookSalesDemoDismissed',
  'bookSalesDemoEmbedFailed',
] as const;

export const bookSalesDemoEvents = getMappedEvents([...EVENTS], { shouldSendSubscriptionData: true });
